import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, X } from 'lucide-react';
import { getCurrentUser } from '@/data/users';

const API = process.env.REACT_APP_BACKEND_URL;
const efateDay = (d) => new Date(new Date(d).getTime() + 11 * 3600e3).toISOString().slice(0, 10);

export const MissedRollCallBanner = () => {
  const user = getCurrentUser();
  const [items, setItems] = useState([]);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!user?.id || user.role !== 'teacher') return;
    fetch(`${API}/api/notifications/my-notifications?user_id=${user.id}&unread_only=true`, { headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` } })
      .then((r) => (r.ok ? r.json() : []))
      .then((list) => setItems(list.filter((n) => n.type === 'attendance_reminder' && n.created_at && efateDay(n.created_at.endsWith('Z') || n.created_at.includes('+') ? n.created_at : `${n.created_at}Z`) === efateDay(Date.now()))))
      .catch(() => {});
  }, [user?.id, user?.role]);

  if (hidden || items.length === 0) return null;
  return (
    <div className="mb-4 rounded-lg border border-red-300 bg-red-50 text-red-900 px-4 py-3 flex items-start gap-3" data-testid="missed-rollcall-banner">
      <AlertCircle className="h-5 w-5 mt-0.5 shrink-0" />
      <div className="flex-1 text-sm">
        <p className="font-semibold">Roll call still missing today</p>
        <p>{items.map((n) => n.title.replace('Roll call missing: ', '')).join(', ')} — <Link to="/dashboard/roll-call" className="underline font-medium" data-testid="missed-rollcall-link">open Roll Call</Link> to fill it in.</p>
      </div>
      <button onClick={() => setHidden(true)} className="p-1 rounded hover:bg-red-100" aria-label="Dismiss" data-testid="missed-rollcall-dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
};
